import React, { useRef } from 'react';
import { useGSAP } from '@gsap/react';
import gsap from 'gsap';

const companies = [
  'Teva', 'Google', 'Microsoft', 'Cybereason',
  'Nice', 'Check Point', 'Cobra', 'Discount',
];

const TickerItem = ({ name }) => (
  <div className="flex items-center shrink-0 px-8">
    <span className="text-2xl font-bold text-gray-700 whitespace-nowrap tracking-wide">
      {name}
    </span>
    <span className="ml-8 text-pink-400 text-3xl">·</span>
  </div>
);

const CompanyTicker = () => {
  const wrapperRef = useRef(null);
  const trackRef = useRef(null);

  useGSAP(() => {
    const track = trackRef.current;
    if (!track) return;

    const singleSetWidth = track.scrollWidth / 4;

    gsap.to(track, {
      x: -singleSetWidth,
      duration: 22,
      ease: 'none',
      repeat: -1,
      modifiers: {
        x: gsap.utils.unitize((x) => parseFloat(x) % singleSetWidth),
      },
    });
  }, { scope: wrapperRef });

  const repeated = [...companies, ...companies, ...companies, ...companies];

  return (
    <section className="py-14 bg-gradient-to-r from-pink-50 via-white to-purple-50 overflow-hidden border-y border-gray-100">
      <div className="text-center mb-8">
        <h2 className="text-3xl font-bold text-gray-800">חברות שגייסתי עבורן</h2>
        <p className="text-gray-500 mt-2">ניסיון עם המובילים בתחום</p>
      </div>
      <div ref={wrapperRef} className="relative w-full overflow-hidden">
        <div
          ref={trackRef}
          className="flex items-center"
          style={{ willChange: 'transform' }}
        >
          {repeated.map((name, i) => (
            <TickerItem key={i} name={name} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default CompanyTicker;
